import allMandants from 'src/config/mandant';

interface Tariff {
  type: string;
  heading: string;
}
export const availableMandants = ['sdk', 'levelnine', 'hallesche', 'vmk'];
export const REACT_APP_TARIFFTYPES: Tariff[] = [
  {
    type: 'Ambulant',
    heading: 'Ambulant',
  },
  {
    type: 'Stationär',
    heading: 'Krankenhaus',
  },
  {
    type: 'Zahn',
    heading: 'Zahn',
  },
  {
    type: 'Pflegetagegeld',
    heading: 'Pflegezusatz',
  },
  {
    type: 'Krankentagegeld',
    heading: 'Krankentagegeld',
  },
  {
    type: 'Vorsorge',
    heading: 'Vorsorge',
  },
];

export const VORSORGE_TARIFF_IDS = ['SDKV#', 'SDKVK#', 'SDKVF#'];

export const VORSORGE_TARIFF_TYPE = 'Vorsorge';

export const isVorsorgeEnabled = (): boolean =>
  process.env.REACT_APP_VORSORGE_ENABLED === 'true';

export const getTariffTypeOptions = (mandant: string): Tariff[] => {
  if (mandant === 'hallesche') {
    return REACT_APP_TARIFFTYPES.filter(
      (tariff) => tariff.type !== VORSORGE_TARIFF_TYPE
    );
  }
  const types =
    mandant === 'sdk' && isVorsorgeEnabled()
      ? ['Ambulant', 'Stationär', 'Zahn', VORSORGE_TARIFF_TYPE]
      : ['Ambulant', 'Stationär', 'Zahn'];
  return REACT_APP_TARIFFTYPES.filter((tariff) => types.includes(tariff.type));
};

export const getDefaultTariffTypes = (mandant: string): string[] => {
  const types = (process.env.REACT_APP_TARIFFTYPES || '').split(',');
  if (mandant === 'sdk' && isVorsorgeEnabled()) {
    return [...types, VORSORGE_TARIFF_TYPE];
  }
  return types;
};

export const stripDisabledTariffTypes = (types: string[]): string[] =>
  isVorsorgeEnabled()
    ? types
    : types.filter((type) => type !== VORSORGE_TARIFF_TYPE);

export const getBlacklistedTariffs = (mandant: string): string[] => {
  const blacklisted = allMandants[mandant]?.blacklistedTariffs ?? [];
  return isVorsorgeEnabled()
    ? blacklisted
    : [...blacklisted, ...VORSORGE_TARIFF_IDS];
};

export const getTariffOrder = (mandant: string): string[] => {
  return allMandants[mandant]?.tariffOrder ?? [];
};
